import axios from 'axios';
import React, { useEffect, useState } from 'react'

export default function Listlayananabooking({ kodebooking }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [layanan, setLayanan] = useState([]);

    const getLayanan = async (kode) => {
        try {
            const response = await axios.get(urlapi + "Layanan?kode=" + kode);
            console.log(response.data);
            setLayanan(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getLayanan(kodebooking)
    }, [])
    return (
        <div>
            <hr />
            <div className='d-flex justify-content-between'>

                <div style={{ fontSize: '12px', color: '#2b2e5a' }}>
                    <div className='mb-2 fw-bold text-secondary'> <i className='fas fa-plus-circle'></i> Layanan :</div>
                    {layanan.foto != 0 || layanan.foto2 != '' ? <><i className='fas fa-camera'></i> Fotograper</> : ''}
                    {' '}
                    {layanan.wasit != 0 || layanan.wasit2 != '' ? <><i className='fas fa-user'></i> Wasit</> : ''}
                    {' '}
                    {layanan.bola != 0 || layanan.bola2 != '' ? <><i className='fas fa-futbol'></i> Bola</> : ''}
                    {' '}
                    {layanan.rompi != 0 || layanan.rompi2 != '' ? <><i className='fas fa-shirt'></i> Rompi</> : ''}

                    {layanan.foto == 0 && layanan.foto2 == '' && layanan.wasit == 0 && layanan.wasit2 == '' && layanan.bola == 0 && layanan.bola2 == '' && layanan.rompi == 0 && layanan.rompi2 == '' ? <> <i className='fas fa-warning'></i> Layanan anda tidak tersedia</> : ''}
                </div>

                <div className={layanan.foto == 0 && layanan.foto2 == '' && layanan.wasit == 0 && layanan.wasit2 == '' && layanan.bola == 0 && layanan.bola2 == '' && layanan.rompi == 0 && layanan.rompi2 == '' ? 'd-none' : ''} style={{ fontSize: '12px' }}>
                    <div className='fw-bold text-secondary' style={{ textAlign: 'right' }}>Status :</div>
                    <div className='mt-2 fw-bold'>{layanan.status == 0 ? <><i className='fas fa-hourglass-start text-warning'></i> Menunggu</> : layanan.status == 400 ? <><i className='fas fa-circle-xmark text-danger'></i> Ditolak</> : <><i className='fas fa-circle-check text-success'></i> Disetujui</>}</div>
                </div>


            </div>
        </div>

    )
}
